// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","hasSubmenu":"Header_hasSubmenu__2qiFF","subMenu":"Header_subMenu__3Mi72"};